import { installAssetPreloadRecovery as _installAssetPreloadRecovery } from "./assetRecovery";
import { copyToClipboard as _copyToClipboard } from "./clipboard";
import {
	downloadAttachment as _downloadAttachment,
	downloadAttachments as _downloadAttachments,
	downloadBlob as _downloadBlob,
	downloadFile as _downloadFile,
	downloadFiles as _downloadFiles,
	downloadGroupsOfFiles as _downloadGroupsOfFiles,
	downloadURL as _downloadURL,
	downloadZip as _downloadZip,
	loadAttachment as _loadAttachment,
	loadURL as _loadURL,
	openURL as _openURL,
} from "./download";

export namespace Browser {
	export const copyToClipboard = _copyToClipboard;
	export const downloadAttachment = _downloadAttachment;
	export const downloadAttachments = _downloadAttachments;
	export const downloadBlob = _downloadBlob;
	export const downloadFile = _downloadFile;
	export const downloadFiles = _downloadFiles;
	export const downloadGroupsOfFiles = _downloadGroupsOfFiles;
	export const downloadURL = _downloadURL;
	export const downloadZip = _downloadZip;
	export const installAssetPreloadRecovery = _installAssetPreloadRecovery;
	export const loadAttachment = _loadAttachment;
	export const loadURL = _loadURL;
	export const openURL = _openURL;
}
